(function () {
  function init() {
    var root = document.getElementById('wfp-bnpl');
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    var current = root.querySelector('#wfp-current-turnover');
    var avgCheck = root.querySelector('#wfp-avg-check');
    var bnplShare = root.querySelector('#wfp-bnpl-share');
    if (!current || !avgCheck || !bnplShare) return;

    var currentVal = root.querySelector('#wfp-current-turnover-val');
    var avgCheckVal = root.querySelector('#wfp-avg-check-val');
    var bnplShareVal = root.querySelector('#wfp-bnpl-share-val');

    var nowOut = root.querySelector('#wfp-now');
    var withBnplOut = root.querySelector('#wfp-with-bnpl');
    var lostYearOut = root.querySelector('#wfp-lost-year');

    function fmt(n) {
      return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(Math.round(n));
    }
    function fmtCompact(n) {
      if (n >= 1000000) return (n / 1000000).toFixed(1).replace('.', ',') + 'M';
      if (n >= 1000) return Math.round(n / 1000) + 'K';
      return fmt(n);
    }

    function recalc() {
      var t = parseInt(current.value, 10);
      var c = parseInt(avgCheck.value, 10);
      var s = parseInt(bnplShare.value, 10) / 100;

      var multiplier = (s / (1 - s)) * 0.7;
      if (s >= 0.95) multiplier = 1;
      var withBnpl = t + t * multiplier;

      var checkFactor = 0.5 + (c / 30000);
      if (checkFactor > 1.6) checkFactor = 1.6;
      var withBnplAdj = t + (withBnpl - t) * checkFactor;
      var lostYearAdj = (withBnplAdj - t) * 12;

      if (currentVal) currentVal.textContent = fmt(t) + ' ₴';
      if (avgCheckVal) avgCheckVal.textContent = fmt(c) + ' ₴';
      if (bnplShareVal) bnplShareVal.textContent = s * 100 + ' %';

      if (nowOut) nowOut.textContent = fmtCompact(t);
      if (withBnplOut) withBnplOut.textContent = fmtCompact(withBnplAdj);
      if (lostYearOut) lostYearOut.textContent = fmtCompact(lostYearAdj);
    }

    current.addEventListener('input', recalc);
    avgCheck.addEventListener('input', recalc);
    bnplShare.addEventListener('input', recalc);

    recalc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
